export enum UserHistoryModalType {
  TRANSFER = 'TRANSFER',
  USER = 'USER',
}
